var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowCompanyIndicator && _vm.companyName)?_c('b-badge',{staticClass:"active-company-pill",attrs:{"pill":"","variant":"light","title":_vm.companyName}},[_vm._v(_vm._s(_vm.companyName))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }